// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"HealthList--next-sr-only--W0W52nJ","dialog":"HealthList--dialog--EacINm7","btn":"HealthList--btn--1gTbSt7","input":"HealthList--input--12cgsSW"};